import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CorrectiveAction } from '../models/corrective-action.model';
import { CreateCorrectiveActionRequest } from '../models/requests/create-corrective-action-request';
import { UpdateCorrectiveActionRequest } from '../models/requests/update-corrective-action-request';

@Injectable({
  providedIn: 'root',
})
export class CorrectiveActionService {
  constructor(private apiService: ApiService) {}

  public GetByRuleUid(
    ruleUniqueId: string | undefined
  ): Observable<CorrectiveAction[]> {
    const options = {
      queryParams: {
        ruleUniqueId: ruleUniqueId ? ruleUniqueId.toString() : '',
      },
    };
    return this.apiService.get<CorrectiveAction[]>(
      `/CorrectiveAction/GetByRuleUid`,
      options
    );
  }

  public DeleteMultipleCorrectiveActions(uids: string[]): Observable<any> {
    return this.apiService.post(`/CorrectiveAction/DeleteMultiple`, uids);
  }

  public UpdateMultipleCorrectiveActions(
    payload: UpdateCorrectiveActionRequest[]
  ): Observable<CorrectiveAction[]> {
    return this.apiService.put<CorrectiveAction[]>(
      `/CorrectiveAction/UpdateMultiple`,
      payload
    );
  }

  public CreateMultipleCorrectiveActions(
    payload: CreateCorrectiveActionRequest[]
  ): Observable<CorrectiveAction[]> {
    return this.apiService.post<CorrectiveAction[]>(
      `/CorrectiveAction/CreateMultiple`,
      payload
    );
  }
}
